export enum eEscrowPrepaymentsAtClosing {
  homeowners_insurance = 'homeowners_insurance',
  mortgage_insurance = 'mortgage_insurance',
  property_tax = 'property_tax',
}
